/**
 * Flatten effective_permissions from /api/auth/me (D39).
 * Mirrors backend utils/rolePermissionsFlatten.js
 */
export function hasServerEffectivePermission(flatList, requiredPermission) {
  if (!Array.isArray(flatList) || !requiredPermission) return false;
  if (flatList.includes('*')) return true;
  return flatList.includes(requiredPermission);
}

export function hasServerEffectivePermissions(flatList, permissions, requireAll = true) {
  if (!Array.isArray(flatList) || !permissions?.length) return false;
  if (flatList.includes('*')) return true;
  if (requireAll) {
    return permissions.every((p) => flatList.includes(p));
  }
  return permissions.some((p) => flatList.includes(p));
}
